import React, { useEffect, useState } from "react";
import {
  Button as MuiButton,
  Box as MuiBox,
  TextField as MuiTextField,
  CircularProgress
} from "@mui/material";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { spacing, SpacingProps } from "@mui/system";
import { Link as LinkRouter, useNavigate } from "react-router-dom";
import { Papercontainer } from "@rewardle/apps.ui.papercontainer.papercontainer";
import styled from "@emotion/styled";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import axios from "axios";
import Loader from "../../components/loader/loader";

const Box = styled(MuiBox)`
  display: flex;
  gap: 28px;
  margin-top: 32px;
`;

const TextField = styled(MuiTextField)`
  display: flex;
  padding-top: 1px;
  justify-content: center;
  align-items: center label {
    color: var(--light-text-secondary, rgba(0, 0, 0, 0.6));
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Montserrat", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0.15px;
  }

  input {
    color: var(--light-text-secondary, rgba(0, 0, 0, 0.6));
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.15px;
    &::before {
      height: 1px;
      background: rgba(0, 0, 0, 0.42);
    }
    &:hover:not(.Mui-disabled)::before {
      height: 1px;
      background: rgba(0, 0, 0, 0.42);
    }
  }
`;

interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}
const Button = styled(MuiButton)<ButtonProps>(spacing);

const CustomButton: any = styled(MuiButton)`
  margin-top: 30px;
  &.blue_button {
    background-color: blue;
  }

  &.custom_disabled {
    background-color: grey !important;
  }
`;

function Payments() {
  let currentBusiness: any = localStorage?.getItem("currentBusiness");
  const state: any = {
    token: localStorage?.getItem("businessAccessToken"),
    currentBusiness: currentBusiness ? JSON.parse(currentBusiness) : null
  };

  const [paymentdetails, setPaymentdetails] = useState<any>({
    AccountName: "",
    BSB: "",
    AccountNumber: ""
  });

  const [validationErrors, setValidationErrors] = useState<any>({
    AccountName: "",
    BSB: "",
    AccountNumber: ""
  });

  const [loading, setiSLoading] = useState(false);
  const [addOrUpdateLoading, setiSAddOrUpdateLoading] = useState(false);
  const [checkIsAddOrUpdate, setCheckIsAddOrUpdate] = useState("Add");
  const [errorMessageNotification, setErrorNotification] = useState<any>({
    message: null,
    color: null
  });

  const validateField = (field: string, value: string) => {
    let errorMessage = "";

    if (
      field === "AccountName" ||
      field === "BSB" ||
      field === "AccountNumber"
    ) {
      if (!value) {
        errorMessage = `${field} cannot be empty`;
      }
    }

    setValidationErrors({ ...validationErrors, [field]: errorMessage });
  };

  const checkIdUpdateOrNot = () => {
    if (
      paymentdetails?.AccountName ||
      paymentdetails?.AccountNumber ||
      paymentdetails?.BSB ||
      paymentdetails?.Email
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleInputChange = (field: string, value: string) => {
    setPaymentdetails({ ...paymentdetails, [field]: value });
    validateField(field, value);
  };

  const handlePinKeyPress = (e: {
    which: any;
    keyCode: any;
    preventDefault: () => void;
  }) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (
      (charCode < 48 || charCode > 57) &&
      charCode !== 101 &&
      charCode !== 69
    ) {
      e.preventDefault();
    }
  };

  const checkIsDisableButton = () => {
    if (
      !paymentdetails?.AccountName ||
      !paymentdetails?.BSB ||
      !paymentdetails?.AccountNumber
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getPaymentDetails = () => {
    setiSLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/paymentgtwayapi/v1/business/account/${state?.currentBusiness?.BusinessId}`,
      headers: {
        Authorization: "Bearer " + state?.token,
        "Content-Type": "application/json"
      }
    };

    axios
      .request(config)
      .then((response) => {
        console.log(
          "🚀 ~ file: Payments.tsx:163 ~ .then ~ response:",
          response
        );
        if (response.data) {
          setPaymentdetails(response.data);
          setCheckIsAddOrUpdate("Update");
        }
        setiSLoading(false);
      })
      .catch((error) => {
        setiSLoading(false);
        console.log(
          "🚀 ~ file: Payments.tsx:167 ~ getPaymentDetails ~ error:",
          error
        );
      });
  };

  useEffect(() => {
    getPaymentDetails();
  }, [state?.currentBusiness?.BusinessId]);

  const postOrPutPaymentDetails = (method: string, apiUrl: string) => {
    setiSAddOrUpdateLoading(true);
    let requestBody = { ...paymentdetails };
    if (method === "post") {
      requestBody.BusinessId = state?.currentBusiness?.BusinessId;
      requestBody.BusinessName = state?.currentBusiness?.BusinessName;
    }
    let data = JSON.stringify(requestBody);

    let config = {
      method: method,
      maxBodyLength: Infinity,
      url: apiUrl,
      headers: {
        Authorization: "Bearer " + state?.token,
        "Content-Type": "application/json"
      },
      data: data
    };

    axios
      .request(config)
      .then((response: any) => {
        console.log(
          "🚀 ~ file: Payments.tsx:225 ~ .then ~ response:",
          response
        );
        setiSAddOrUpdateLoading(false);
        setErrorNotification({
          message:
            method === "post"
              ? "Business Account Details created successfully"
              : "Business Account Details updated successfully",
          color: "success"
        });
        getPaymentDetails();
      })
      .catch((error: any) => {
        console.log(error);
        setiSAddOrUpdateLoading(false);
        setErrorNotification({
          message: error?.response?.message,
          color: "error"
        });
      });
  };

  return (
    <React.Fragment>
      <Breadcrumbs
        heading="Payment Details"
        subHeading="Create/Update Payment"
        docs={null}
      />
      {loading ? (
        <Papercontainer elevation={0}>
          <Loader />
        </Papercontainer>
      ) : (
        <Papercontainer elevation={0}>
          {errorMessageNotification?.message &&
            errorMessageNotification?.color && (
              <Stack sx={{ width: "100%", mb: 2 }} spacing={2}>
                <Alert severity={errorMessageNotification?.color}>
                  {errorMessageNotification?.message}
                </Alert>
              </Stack>
            )}

          <Box display={"flex"} flexDirection={"row"}>
            <TextField
              id="standard-version-input"
              label="AccountName"
              type="text"
              autoComplete="current-version"
              variant="standard"
              value={paymentdetails?.AccountName}
              onChange={(e) => handleInputChange("AccountName", e.target.value)}
              fullWidth={true}
              size="medium"
              error={!!validationErrors.AccountName}
            />
          </Box>
          <Box display={"flex"} flexDirection={"row"}>
            <TextField
              id="standard-version-input"
              label="BSB"
              type="text"
              autoComplete="current-version"
              variant="standard"
              value={paymentdetails?.BSB}
              onChange={(e) => handleInputChange("BSB", e.target.value)}
              onKeyPress={handlePinKeyPress}
              inputMode="numeric"
              fullWidth={true}
              size="medium"
              error={!!validationErrors.BSB}
            />

            <TextField
              id="standard-version-input"
              label="AccountNumber"
              type="text"
              autoComplete="current-version"
              variant="standard"
              value={paymentdetails?.AccountNumber}
              onChange={(e) =>
                handleInputChange("AccountNumber", e.target.value)
              }
              onKeyPress={handlePinKeyPress}
              inputMode="numeric"
              fullWidth={true}
              size="medium"
              error={!!validationErrors.AccountNumber}
            />
          </Box>

          <CustomButton
            variant="contained"
            color="secondary"
            mt={4}
            className={`blue_button ${
              Object.values(validationErrors).some((error) => !!error) ||
              addOrUpdateLoading ||
              checkIsDisableButton()
                ? "custom_disabled"
                : ""
            }`}
            onClick={() => {
              if (checkIsAddOrUpdate === "Update")
                postOrPutPaymentDetails(
                  "put",
                  `${process.env.REACT_APP_API_BASE_URL}/paymentgtwayapi/v1/business/account?businessid=${state?.currentBusiness?.BusinessId}`
                );
              else
                postOrPutPaymentDetails(
                  "post",
                  `${process.env.REACT_APP_API_BASE_URL}/paymentgtwayapi/v1/business/account`
                );
            }}
            disabled={
              Object.values(validationErrors).some((error) => !!error) ||
              addOrUpdateLoading ||
              checkIsDisableButton()
            }
          >
            {addOrUpdateLoading ? (
              <CircularProgress size={25} color="inherit" />
            ) : (
              checkIsAddOrUpdate
            )}
          </CustomButton>
        </Papercontainer>
      )}
    </React.Fragment>
  );
}

export default Payments;
